const OTP_VERIFICATION_TYPE = {
  EMAIL: 'email',
  SMS: 'sms',
};

const SERVICE_NAME = {
  FIGO: 'Figo',
  PPI: 'PPI',
  PPU: 'PPU',
  SPOT: 'Spot',
};

export { OTP_VERIFICATION_TYPE, SERVICE_NAME };
